import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownFolderItem } from './item/DropdownFolderItem';
import { Connect, PropsFromRedux } from './DropdownFolderListContainer';
import { Folder } from '../../../folders.types';
import { SearchFolders } from '../../foldersDropdown.utils';
import { DropdownSearchFolders } from './search/DropdownSearchFolders';
import styles from './dropdown_folder_list.module.scss';
import { withFolderDropdown } from '../../FoldersDropdownContext';
import {
  FoldersDropdownContextType,
  FolderSelectionType,
} from '../../foldersDropdown.types';

type Props = {
  onFolderSelect: ({
    folder,
    searchActive,
  }: {
    folder: FolderSelectionType;
    searchActive: boolean;
  }) => void;
} & PropsFromRedux &
  FoldersDropdownContextType;

type State = {
  focus: boolean;
  filteredFolders: Array<Folder>;
};

export class RawDropdownFolderList extends React.Component<Props, State> {
  static defaultProps = {
    folders: [],
  };

  state: State = {
    focus: false,
    filteredFolders: this.props.folders,
  };

  SearchFolders = new SearchFolders(this.props.folders);

  handleChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    const { saveSearchValue } = this.props;
    this.setState({
      filteredFolders: this.SearchFolders.matchTitle(value),
    });
    saveSearchValue(value);
  };

  handleFocus = () => this.setState(({ focus }) => ({ focus: !focus }));

  handleFolderSelection = (folder: FolderSelectionType) => {
    const { onFolderSelect, searchValue } = this.props;
    onFolderSelect({ folder, searchActive: !!searchValue });
  };

  render() {
    const { folders } = this.props;
    const { focus, filteredFolders } = this.state;
    const showSearchFolders = folders.length > 3; // display search bar if user has more than 4 folders
    return (
      <>
        {showSearchFolders && (
          <>
            <DropdownSearchFolders
              handleChange={this.handleChange}
              handleFocusAndBlur={this.handleFocus}
              focus={focus}
            />
          </>
        )}
        <div className={styles.subtitle}>
          <FormattedMessage id="folders/dropdown/list/DropdownFolderList.tsx/2" />
        </div>
        <ul id="folders-list">
          {filteredFolders.length ? (
            filteredFolders.map(folder => (
              <DropdownFolderItem
                key={folder.folderKey}
                folder={folder}
                onFolderSelect={this.handleFolderSelection}
              />
            ))
          ) : (
            <div className={styles.empty}>
              <FormattedMessage id="folders/dropdown/list/DropdownFolderList.tsx/1" />
            </div>
          )}
        </ul>
      </>
    );
  }
}

export const DropdownFolderList = Connect(
  withFolderDropdown(RawDropdownFolderList),
);
